import { reducerConstants } from "../../../constants/reducer-constant";
import {
    INITIAL_STATE as sfLandingPageData,
    HANDLERS as sfReducerHandler
} from "../../../components/desktop/sf-landing-page/reducers";

export default {
    [reducerConstants.SF_LANDING]: {
        state: sfLandingPageData,
        handler: sfReducerHandler
    }
};
